export default [{
    path: '/admin/shop/list/index',
    name: 'ShopListIndex',
    component: () => import('../views/shop/list/index'),
    meta: {
      title: '其他管理-自提点列表'
    }
  },
  {
    path: '/admin/shop/verifier/index',
    name: 'ShopVerifierIndex',
    component: () => import('../views/shop/verifier/index'),
    meta: {
      title: '其他管理-师傅列表'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/shop.js